import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer'; // 更新为新的Footer组件名称
import Home from './pages/Home';
import Archive from './pages/Archive';
import WritePost from './pages/WritePost';
import Profile from './pages/Profile';
import Auth from './pages/Auth';
import PostDetail from './pages/PostDetail';
import NotFound from './pages/NotFound';
import About from './pages/About'; // 使用About页面作为MyPage
import './App.css';

function App() {
  return (
    <ConfigProvider locale={zhCN}>
      <AuthProvider>
        <Router>
          <div className="App">
            <Header />
            <div className="main-content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} /> {/* 改为about路由 */}
                <Route path="/archive" element={<Archive />} />
                <Route path="/write" element={
                  <ProtectedRoute>
                    <WritePost />
                  </ProtectedRoute>
                } />
                <Route path="/write/:id" element={
                  <ProtectedRoute>
                    <WritePost />
                  </ProtectedRoute>
                } />
                <Route path="/profile" element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                } />
                <Route path="/auth" element={<Auth />} />
                <Route path="/post/:id" element={<PostDetail />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>
            <Footer />
          </div>
        </Router>
      </AuthProvider>
    </ConfigProvider>
  );
}

// 保护路由组件
const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  
  if (!user) {
    // 重定向到登录页面，并保存返回路径
    return <Navigate to="/auth" state={{ from: location.pathname }} replace />;
  }
  
  return children;
};

export default App;